<template>
  <ContactReviewDisplayComponent
    :accountData="accountData"
    :accountRules="accountRules"
    :companyRules="companyRules"
    :companyIndex="companyIndex"
    :countryCode="'SE'"
    @updateAccountData="$emit('updateAccountData', $event)"
    @handleUpdateCompany="$emit('handleUpdateCompany', $event)"
    @selectExistingCompany="$emit('selectExistingCompany', $event)"
    @resetCompanySelection="$emit('resetCompanySelection')"
  >
    <template #account="{ phoneCountryCode, accountField }">
      <TextRowComponent v-bind="accountField('name')" />
      <TextRowComponent
        v-bind="accountField('phone_number')"
        type="tel"
        :countryCode="phoneCountryCode"
      />
      <TextRowComponent v-bind="accountField('registry_code')" />
    </template>
    <template #company="{ locked, companyField }">
      <TextRowComponent v-bind="companyField('name')" :disabled="locked" />
      <TextRowComponent
        v-bind="companyField('registry_code')"
        :disabled="locked"
      />
      <TextRowComponent v-bind="companyField('address')" :disabled="locked" />
      <TextRowComponent v-bind="companyField('vat')" :disabled="locked" />
    </template>
  </ContactReviewDisplayComponent>
</template>

<script setup lang="ts">
import { useValidators } from "@/composables/useValidators";
import type { AccountRules, CompanyRules } from "@/signup/common/contactFields";
import TextRowComponent from "@/signup/common/TextRowComponent.vue";
import ContactReviewDisplayComponent from "@/signup/ContactReviewDisplayComponent.vue";
import type { Account, Company } from "@/types";
import { useI18n } from "vue-i18n";

defineProps<{
  accountData: Account;
  companyIndex?: number;
}>();

defineEmits<{
  updateAccountData: [accountData: Account];
  handleUpdateCompany: [company: Company];
  selectExistingCompany: [companyId: number];
  resetCompanySelection: [];
}>();

const { t } = useI18n();
const {
  required,
  swedishPersonalID,
  swedishIDorCompanyCode,
  personalName,
  phoneNumber,
  swedishVATNumber,
} = useValidators(t);

const accountRules: AccountRules = {
  name: { required, personalName },
  phone_number: { required, phoneNumber },
  registry_code: { required, swedishPersonalID },
};

const companyRules: CompanyRules = {
  name: { required },
  registry_code: { required, swedishIDorCompanyCode },
  address: { required },
  vat: { swedishVATNumber },
};
</script>

<style scoped lang="scss"></style>
